module.exports = __webpack_public_path__ + "img/left_4.53a6eb24.jpg";